export default "__VITE_ASSET__e9a8d1d9__"